"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const products_1 = require("@phishtool/products");
const expandable_content_section_1 = __importDefault(require("~components/expandable-content-section"));
const faq_1 = __importDefault(require("~components/faq"));
const hero_1 = __importDefault(require("~components/hero"));
const mssp_demo_button_1 = require("~components/mssp-demo-button");
const mssp_pricing_1 = __importDefault(require("~components/mssp-pricing"));
const three_card_section_1 = __importDefault(require("~components/three-card-section"));
const _service_1 = require("~service");
const MSSPs = () => {
    const { data } = _service_1.contentService.useGetMSSPContent({});
    if (!data) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hero_1.default, Object.assign({}, data.hero, { children: (0, jsx_runtime_1.jsx)(mssp_demo_button_1.MSSPDemoButton, {}) })), (0, jsx_runtime_1.jsx)(three_card_section_1.default, Object.assign({}, data.threeCardSection)), (0, jsx_runtime_1.jsx)(expandable_content_section_1.default, Object.assign({}, data.expandableContentSection)), (0, jsx_runtime_1.jsx)(mssp_pricing_1.default, Object.assign({}, data.pricing)), (0, jsx_runtime_1.jsx)(faq_1.default, Object.assign({}, data.faq)), (0, jsx_runtime_1.jsx)(products_1.UnauthenticatedSalesModal, { source: "web-mssp", useContactSalesTeam: _service_1.unauthenticatedUserService.useContactSalesTeam })] }));
};
exports.default = MSSPs;
